var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.initialized)?_c('div',[_vm._t("default",null,{"title":_vm.title,"duration":_vm.duration})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }